import React from 'react';
import { Heart, Shield, Users, ArrowRight } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Beginners = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Olá! Nunca treinei antes e gostaria de agendar minha primeira aula experimental."
    );
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <section className="py-24 bg-gradient-to-br from-bg-page via-bg-card to-bg-page relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-64 h-64 bg-brand-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-brand-primary rounded-full blur-3xl"></div>
      </div>
      
      {/* Background Image */}
      <div className="absolute right-0 top-0 w-1/2 h-full opacity-10">
        <img
          src="https://images.unsplash.com/photo-1611824916163-a984d622d042"
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-bg-page via-bg-page/50 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-block bg-brand-primary/20 border-2 border-brand-primary rounded-full px-6 py-2 mb-6">
              <span className="text-brand-primary font-black text-sm uppercase tracking-wide">
                👊 Sem Experiência? Sem Problema!
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-black text-white mb-6 uppercase">
              Iniciantes São Muito Bem-Vindos
            </h2>
            <p className="text-2xl text-gray-300 max-w-3xl mx-auto font-medium">
              Não importa sua idade, forma física ou experiência. Se você quer começar, este é o lugar certo.
            </p>
          </div>

          {/* Features Grid com imágenes e íconos grandes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {/* Ambiente Acolhedor */}
            <div className="relative group overflow-hidden rounded-2xl">
              <div 
                className="absolute inset-0 opacity-20 group-hover:opacity-40 transition-opacity duration-500 bg-cover bg-center grayscale"
                style={{ backgroundImage: "url('welcoming_gym_community_bg_1774631532611.png')" }}
              ></div>
              <div className="relative bg-bg-card/80 border-2 border-border-strong rounded-2xl p-8 hover:border-brand-primary transition-all text-center h-full flex flex-col items-center">
                <div className="w-24 h-24 bg-gradient-to-br from-brand-primary to-red-700 rounded-full flex items-center justify-center mb-6 shadow-2xl shadow-brand-primary/50 relative z-10">
                  <Heart className="w-12 h-12 text-white" />
                </div>
                <h3 className="text-2xl font-black text-white mb-3 relative z-10">
                  Ambiente Acolhedor
                </h3>
                <p className="text-base text-gray-400 leading-relaxed relative z-10">
                  Ninguém nasce sabendo. Nossos professores ensinam do zero com paciência e técnica.
                </p>
              </div>
            </div>

            {/* Treino Seguro */}
            <div className="relative group overflow-hidden rounded-2xl">
              <div 
                className="absolute inset-0 opacity-20 group-hover:opacity-40 transition-opacity duration-500 bg-cover bg-center grayscale"
                style={{ backgroundImage: "url('safe_training_pads_bg_1774631606275.png')" }}
              ></div>
              <div className="relative bg-bg-card/80 border-2 border-border-strong rounded-2xl p-8 hover:border-brand-primary transition-all text-center h-full flex flex-col items-center">
                <div className="w-24 h-24 bg-gradient-to-br from-brand-primary to-red-700 rounded-full flex items-center justify-center mb-6 shadow-2xl shadow-brand-primary/50 relative z-10">
                  <Shield className="w-12 h-12 text-white" />
                </div>
                <h3 className="text-2xl font-black text-white mb-3 relative z-10">
                  Treino Seguro
                </h3>
                <p className="text-base text-gray-400 leading-relaxed relative z-10">
                  Progressão respeitosa e controlada. Você evolui no seu ritmo, sem pressão.
                </p>
              </div>
            </div>

            {/* Turmas Para Iniciantes */}
            <div className="relative group overflow-hidden rounded-2xl">
              <div 
                className="absolute inset-0 opacity-20 group-hover:opacity-40 transition-opacity duration-500 bg-cover bg-center grayscale"
                style={{ backgroundImage: "url('kids_martial_arts_subtle_bg_v2_1774631577085.png')" }}
              ></div>
              <div className="relative bg-bg-card/80 border-2 border-border-strong rounded-2xl p-8 hover:border-brand-primary transition-all text-center h-full flex flex-col items-center">
                <div className="w-24 h-24 bg-gradient-to-br from-brand-primary to-red-700 rounded-full flex items-center justify-center mb-6 shadow-2xl shadow-brand-primary/50 relative z-10">
                  <Users className="w-12 h-12 text-white" />
                </div>
                <h3 className="text-2xl font-black text-white mb-3 relative z-10">
                  Turmas Para Iniciantes
                </h3>
                <p className="text-base text-gray-400 leading-relaxed relative z-10">
                  Você não vai treinar sozinho. Turmas específicas para quem está começando.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial destacado com visual mejorado */}
          <div className="relative mb-12">
            <div className="absolute inset-0 bg-gradient-to-r from-brand-primary/10 to-transparent rounded-2xl blur-2xl"></div>
            <div className="relative bg-gradient-to-br from-bg-card to-black border-2 border-brand-primary/50 rounded-2xl p-10">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 bg-gradient-to-br from-brand-primary to-red-700 rounded-full flex items-center justify-center shadow-xl">
                    <span className="text-white font-black text-2xl">RC</span>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-center mb-4">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="text-secondary-yellow text-2xl">★</span>
                    ))}
                  </div>
                  <p className="text-xl text-white mb-6 italic leading-relaxed">
                    "Tinha medo de começar porque nunca tinha feito nada parecido. Hoje, 6 meses depois, não me imagino sem esse treino. Os professores são incríveis e o ambiente é totalmente respeitoso. <span className="text-brand-primary font-bold">Qualquer um consegue começar aqui.</span>"
                  </p>
                  <div>
                    <p className="text-lg text-white font-bold">Rafael Costa</p>
                    <p className="text-gray-400">Começou do zero há 8 meses</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Grande e Visual */}
          <div className="text-center">
            <button
              onClick={handleWhatsAppClick}
              className="btn-primary text-xl px-16 py-6 group shadow-2xl shadow-brand-primary/50"
            >
              🥊 Quero Começar do Zero
              <ArrowRight className="w-6 h-6 ml-3 group-hover:translate-x-2 transition-transform" />
            </button>
            <div className="mt-6 flex items-center justify-center space-x-8 text-gray-400">
              <div className="flex items-center space-x-2">
                <span className="text-2xl">✓</span>
                <span>Aula experimental gratuita</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-2xl">✓</span>
                <span>Sem compromisso</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-2xl">✓</span>
                <span>Sem julgamentos</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Beginners;
